
const API_URL='https://admin.daadiskitchen.com.au/api/web-api/'
// const API_URL='https://codexo.store/daadiskitchen/csadmin/api/web-api/'
const FRONT_URL = 'https://daadiskitchen.com.au/'
const Google_api_key="AIzaSyAE7oxhbgUxiIzikhCeN6TB6UUe1frQnZs"
const Default_image='/img/defaultimage.jpg'
const API_URL2=""



const CATEGORIES = [];
const themesetting = {};
export default { API_URL, CATEGORIES, themesetting ,FRONT_URL,API_URL2,Google_api_key ,Default_image};